const best_practices_en = `We have published <a href="https://github.com/dpa-newslab" target="_blank">best practices</a> on how to connect to our APIs on Github.

**NOTE**: These are reference implementations that are not suitable for productive use in this form!

### s3push connection

The following reference implementations are available for the s3push-API:

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-s3push-example" target="_blank">Receive s3push via AWS, conversion to another format with AWS lambda functions (JavaScript)</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-s3push-wordpress" target="_blank">Receive s3push via AWS, forwarding to WordPress REST API (JavaScript, PHP)</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-s3push-webhook" target="_blank">Receive s3push via AWS, forwarding to CMS API endpoint, with asynchronous import status check (Python)</a>

### wireQ-API connection

The following reference implementations are available for the wireQ-API:

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-wireq-example" target="_blank">Requesting the wireQ-API (GET/DELETE or POST) and storing in the local filesystem (Python)</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-wireq-wordpress-plugin" target="_blank">WordPress plugin importing wireQ-articles via WordPress-cronjob</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-wireq-java-example" target="_blank">Requesting the wireQ-API (GET/DELETE or POST) and forwarding to ActiveMQ (Java)</a>

### Conversion of dpa-digitalwires into other formats

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-to-iptc7901" target="_blank">A Python library which transforms entries from the dpa-digitalwires format into an approximate IPTC 7901 article format</a>

### Embedded content via Web Components

We use Web Components to display social media embeds, graphics, positioned images and other multimedia contents within an article. A reference implementation can be found here:

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-embeds" target="_blank">dpa-digitalwires-embeds</a>

You can integrate the embedded content into your content management platform (i.e. Opt-In, Two-Click, Opt-Out, ...) based on this reference implementation or your own existing web components.

### Miscellaneous

We collect code snippets for recurring, small tasks with the dpa-digitalwires format in an <a href="https://github.com/dpa-newslab/dpa-digitalwires-snippets" target="_blank">extra repository</a>.

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-snippets/tree/main/table-of-contents" target="_blank">Creation of a table of contents with deep links to all subtitles</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-snippets/tree/main/weblines-single-rubric-name" target="_blank">Selection of the most important dpa-Weblines rubric for a multi-rubric article</a>
`

export { best_practices_en }


// WEBPACK FOOTER //
// ./src/all_cards/docu/best_practices_en.js